/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { Toast } from '../components';
import { Loader } from '../components/loader';
import { useAuthState } from '../context/auth';
import { useGlobalToast } from '../hooks';
import { decodeToken } from '../lib/jwt';
import { RoutePageProps } from '../routing';
import { RouteLocationState } from '../types/location';

const Dashboard: React.FC<RoutePageProps> = ({ route }: RoutePageProps): React.ReactElement | null => {
  const { accessToken } = useAuthState();
  const { toastProps } = useGlobalToast();

  const location = useLocation<RouteLocationState>();

  const initialRoute = location.pathname;

  if (route === null || route === undefined || !accessToken) {
    return <Redirect to={{ pathname: '/', state: { from: initialRoute } }} />;
  }

  const userToken = decodeToken(accessToken);
  const pagePermissions = route.permissions || [];

  if (pagePermissions.length > 0 && pagePermissions.filter((p) => userToken.scope.includes(p)).length === 0) {
    return <Redirect to="/forbidden" />;
  }

  return (
    <div className="app">
      <div className="app-body">
        <main className="main">
          <Loader>
            <route.page route={route} />
          </Loader>
        </main>
      </div>
      {toastProps && <Toast {...toastProps} />}
    </div>
  );
};

export default Dashboard;
